import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";

import FormFieldRenderer from "@/components/FormData/lib/layout/Renderers/FormFieldRenderer.tsx";
import {
  StyledRow,
  StyledSection,
  StyledSectionTitle,
  StyledStepTitle,
  StyledSubSection,
  StyledSubSectionTitle,
} from "@/components/FormData/lib/layout/Renderers/styles.ts";
import TranslationFailureIndicator from "@/components/FormData/lib/layout/Renderers/TranslationFailureIndicator.tsx";

import NavigationRenderer from "./NavigationRenderer.tsx";

interface StepRendererProps {
  stepNumber: number;
}

const StepRenderer = ({ stepNumber }: StepRendererProps) => {
  const { findStepByNumber, translator, translatorFor } = useFormDataContext();

  const step = findStepByNumber(stepNumber);

  return (
    <div>
      <StyledStepTitle variant='title5'>{`${translatorFor(step).with(step).title()}`}</StyledStepTitle>
      <TranslationFailureIndicator targetId={step} />

      {step.hasAtLeastOneFieldToBeDisplayed() ? (
        step.sections
          .filter((item) => item.mustBeDisplayed())
          .map((section) => (
            <StyledSection key={"section-" + section.number}>
              <StyledSectionTitle variant='title2'>{`${translator.with(section)}`}</StyledSectionTitle>

              {section.subSections
                .filter((item) => item.mustBeDisplayed())
                .map((subSection) => (
                  <StyledSubSection key={"sub-section-" + subSection.number}>
                    <StyledSubSectionTitle variant='title3'>{`${translator.with(subSection)}`}</StyledSubSectionTitle>

                    {subSection.rows.map((row) => (
                      <StyledRow key={"row-" + row.number}>
                        {row.fields
                          .filter((item) => item.mustBeDisplayed())
                          .map((field) => (
                            <FormFieldRenderer
                              key={field.id()}
                              fieldId={field.id()}
                              summary={false}
                            />
                          ))}
                      </StyledRow>
                    ))}
                  </StyledSubSection>
                ))}
            </StyledSection>
          ))
      ) : (
        <div>{translator.translate("noFields")}</div>
      )}

      <NavigationRenderer />
    </div>
  );
};

export default StepRenderer;
